/* eslint-disable no-undef */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfills';
import './logging';
import Vue from 'vue';
import App from './App';
import AuthHandler from './components/auth/AuthHandler';
import router from './router';
import i18n from './languages';
import store from './store';
import vmodal from 'vue-js-modal';
import {axiosInstance, responseInterceptor, requestInterceptor} from '@/api';
import VueAxios from 'vue-axios';
import Notify from 'vue2-notify';

Vue.config.productionTip = false;

// Register the config independent modules.
Vue.use(vmodal);
Vue.use(AuthHandler);

// Default notifications configuration: vue2-notify
Vue.use(Notify, {
    itemClass: '',
    permanent: false,
    duration: 300,
    visibility: 5000,
    position: 'bottom-right'
});

const types = {
    info: {itemClass: 'toaster', iconClass: 'alert__icon mdi mdi-information'},
    error: {itemClass: 'toaster--error', iconClass: 'alert__icon mdi mdi-alert-circle'},
    warning: {itemClass: 'toaster--warning', iconClass: 'alert__icon mdi mdi-alert'},
    success: {itemClass: 'toaster--success', iconClass: 'alert__icon mdi mdi-checkbox-marked-circle'}
};

Vue.$notify.setTypes(types);

const configFileName = process.env.NODE_ENV === 'production' ? 'config.json' : process.env.NODE_ENV + '.json';

axiosInstance.get('/static/' + configFileName)
    .then(response => response.data)
    .then(config => {
        Vue.prototype.$config = config;
        Vue.prototype.$config.debug = process.env.NODE_ENV === 'development';

        // Set the baseURL according to the latest config and register the instance.
        axiosInstance.defaults.baseURL = Vue.prototype.$config.api.url;
        Vue.use(VueAxios, axiosInstance);

        connectAnalytics(config);

        new Vue({
            el: '#app',
            router,
            i18n,
            store,
            template: '<App/>',
            components: {App},
        });
    });


function connectAnalytics(config) {
    // Connect analytics if enabled on production
    if (process.env.NODE_ENV === 'production' && config.analytics && config.analytics.enabled) {
        let VueAnalytics = require('vue-analytics');
        Vue.use(VueAnalytics, {
            id: config.analytics.id,
            router,
            autoTracking: {
                screenview: true,
                pageviewTemplate(route) {
                    return {
                        page: route.path,
                        title: route.name,
                        location: window.location.href
                    };
                }
            }
        });

        if (config.debug) console.log('[ Analytics ]', 'Connected analytics', config.analytics.id);
    }
}






// WEBPACK FOOTER //
// ./src/main.js